'use client';

import { Folder } from 'lucide-react';
import { formatBytes } from '@/lib/utils';

/**
 * The "My files" label + quota readout, ONE composition for its two mounts:
 * Stage's bottom-left corner chip and Discover's pinned footer. Both render
 * the same horizontal row — icon, label, thin usage bar, tabular byte count —
 * so the affordance reads as the same object wherever it appears. The caller
 * owns the button, its chrome and the storage fetch; this is just the face.
 */
export function MyFilesSummary({
  storage,
}: {
  storage: { used: number; quota: number } | null;
}) {
  const pct = storage
    ? Math.min(100, Math.round((storage.used / storage.quota) * 100))
    : null;
  return (
    <>
      <Folder className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
      My files
      {storage && pct !== null && (
        <span className="ml-1.5 inline-flex min-w-0 items-center gap-1.5">
          <span className="h-0.5 w-16 overflow-hidden rounded-full bg-foreground/10">
            <span
              className="block h-full rounded-full bg-foreground"
              style={{ width: `${pct}%` }}
            />
          </span>
          <span className="whitespace-nowrap text-[10px] font-normal tabular-nums text-muted-foreground">
            {formatBytes(storage.used)} of {formatBytes(storage.quota)}
          </span>
        </span>
      )}
    </>
  );
}
